module.exports = __webpack_public_path__ + "static/img/icon-gif.627fe65c.svg";